module.exports = __webpack_public_path__ + "static/img/par6.eb21410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par6.png
// module id = Gjvj
// module chunks = 0